import React, { useEffect, useRef } from 'react';
import PropTypes from "prop-types";
import { useMap, useMapsLibrary } from '@vis.gl/react-google-maps';

const Search = ({ onPlaceSelected, searchID }) => {
  const map = useMap();
  const placesLibrary = useMapsLibrary('places');
  const inputRef = useRef(null);

  useEffect(() => {
    if(!window.google || !inputRef.current) return;
  }, []);

  useEffect(() => {
    if (!placesLibrary || !map || !inputRef.current) return;
    // Initialize Autocomplete
    const autocompleteInstance = new placesLibrary.Autocomplete(inputRef.current, {
      fields: ['place_id', 'geometry', 'name'],  // Specify what details you need
      types: ['geocode'],  // Filter results by type
    });
    // Event listener for when a place is selected
    autocompleteInstance.addListener('place_changed', () => {
      const place = autocompleteInstance.getPlace();
      if (place.geometry) {
        const bounds = place.geometry.viewport;
        const ne = bounds.getNorthEast();
        const sw = bounds.getSouthWest();
        const boundingBox = {
          north: ne.lat(),
          east: ne.lng(),
          south: sw.lat(),
          west: sw.lng(),
        };
        onPlaceSelected(boundingBox);
        map.panTo(place.geometry.location);
        map.setZoom(15);

      }
    });

    return () => {
      // Clear instance listeners if needed
    };
  }, [placesLibrary, map, onPlaceSelected]);

  return (
      <input
      ref={inputRef}
      id={searchID}
      type="text"
      placeholder="🔍︎ Search for places"
      style={{
        boxSizing: 'border-box',
        border: '1px solid hsla(220, 20%, 80%, 0.4)',
        width: '240px',
        height: '40px',
        padding: '0 12px',
        borderRadius: '8px',
        fontSize: '14px',
        outline: 'none',
        textOverflow: 'ellipses',
        left: '50%',
        margin: '10px 0',
      }}
    />
  );
};

export default Search;

Search.propTypes = {
  onPlaceSelected: PropTypes.func.isRequired,
};